"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styler = ({ selectors }) => ({
    tile: {
        display: 'flex',
        width: '100%',
        position: 'relative',
    },
    textCol: {
        flex: 1,
        paddingRight: 10,
    },
    dayOneTileLoading: {
        backgroundColor: selectors.color('neutral10'),
        foregroundColor: selectors.color('neutral30'),
    },
    dayOneTileHeader: {
        fontSize: selectors.fontSize('T300'),
        fontFamily: selectors.fontFamily('primary.bold'),
        fontWeight: '700',
        color: selectors.color('neutral100'),
    },
    dayOneTileTextContent: {
        fontFamily: selectors.fontFamily('primary.regular'),
        color: selectors.color('neutral80'),
        fontWeight: '400',
        fontSize: selectors.fontSize('T200'),
    },
    screenContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f2f2f2',
    },
    rowStyle: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
});
exports.default = styler;
//# sourceMappingURL=styles.js.map